import { apiClient } from './api';

export interface Reservation {
  id: string;
  customerId: string;
  campaignId: string;
  storeId: string;
  scheduledDate: string;
  status: string;
  voucherCode?: string;
  createdAt: string;
}

export interface AvailableDate {
  date: string;
  slotsAvailable: number;
}

export interface Voucher {
  id: string;
  code: string;
  qrCodeUrl: string;
  status: string;
  expiresAt: string;
}

export const reservationService = {
  /** POST /api/v1/customer/reservations */
  create: async (payload: {
    campaignId: string;
    storeId: string;
    redemptionDate: string;
  }): Promise<Reservation> => {
    const { data } = await apiClient.post<Reservation>('/customer/reservations', payload);
    return data;
  },

  /** GET /api/v1/reservation/available-dates?campaignId=xxx&storeId=xxx */
  getAvailableDates: async (campaignId: string, storeId: string): Promise<AvailableDate[]> => {
    const { data } = await apiClient.get<AvailableDate[]>(
      `/reservation/available-dates?campaignId=${campaignId}&storeId=${storeId}`,
    );
    return data;
  },

  /** GET /api/v1/reservation/{id} */
  getById: async (id: string): Promise<Reservation> => {
    const { data } = await apiClient.get<Reservation>(`/reservation/${id}`);
    return data;
  },

  /** GET /api/v1/reservation/customer/{customerId} */
  getByCustomer: async (customerId: string): Promise<Reservation[]> => {
    const { data } = await apiClient.get<Reservation[]>(`/reservation/customer/${customerId}`);
    return data;
  },

  /** GET /api/v1/voucher/{reservationId} */
  getVoucher: async (reservationId: string): Promise<Voucher> => {
    const { data } = await apiClient.get<Voucher>(`/voucher/${reservationId}`);
    return data;
  },

  /** PUT /api/v1/reservation/{id}/confirm */
  confirm: async (id: string): Promise<Reservation> => {
    const { data } = await apiClient.put<Reservation>(`/reservation/${id}/confirm`, {});
    return data;
  },

  /** DELETE /api/v1/reservation/{id} */
  cancel: async (id: string): Promise<void> => {
    await apiClient.delete(`/reservation/${id}`);
  },
};
